// file: src/pages/landing/components/QuickActions.jsx
import React from 'react';
import { FolderPlus, Server, HardDrive } from 'lucide-react';
import ProtectedAction from '../../../components/common/ProtectedAction';
import styles from './QuickActions.module.css';

/**
 * QuickActions component displays action buttons for common home page actions
 * @param {Function} onCreateProject - Callback when "New Project" is clicked
 * @param {Function} onManageServers - Callback when "Manage Servers" is clicked
 * @param {Function} onManageFiles - Callback when "Manage Files" is clicked
 */
function QuickActions({ onCreateProject, onManageServers, onManageFiles }) {
  return (
    <div className={styles.quickActions}>
      <ProtectedAction feature="create_project">
      <button
        onClick={onCreateProject}
        className={styles.actionButton}
      >
        <FolderPlus className={styles.actionIcon} />
        New Project
      </button>
      </ProtectedAction>
      <ProtectedAction feature="start_server">
      <button
        onClick={onManageServers}
        className={styles.actionButton}
      >
        <Server className={styles.actionIcon} />
        Manage Servers
      </button>
      </ProtectedAction>
      <ProtectedAction feature="upload_file">
      <button
        onClick={onManageFiles}
        className={styles.actionButton}
      >
        <HardDrive className={styles.actionIcon} />
        Manage Files
      </button>
      </ProtectedAction>
    </div>
  );
}

export default QuickActions;
